import React, { useState, useEffect, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { FaChevronDown, FaChevronUp, FaCheck, FaTimes, FaSearch } from 'react-icons/fa';
import { MdOutlineStar } from "react-icons/md";
import { useSearchParams, Link } from 'react-router-dom';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import './cat.css';
import axios from 'axios';
import { CartContext } from '../../contexts/CartContext';
import toast from 'react-hot-toast';
import Photo from '../../components/Photo';

const filterOptions = [
  { name: 'Топ 25', color: '#32CD32' },
  { name: 'Подарочные', color: '#FF5733' },
  { name: 'Бестселлер', color: '#FFD700' },
  { name: 'Новинки', color: '#33C1FF' },
  { name: 'Лимитированная серия', color: '#8A2BE2' },
  { name: 'Свежее поступление', color: '#FF1493' },
];

const sortOptions = [
  'Сначала Дешевые',
  'Сначала Дорогие',
  'По размеру скидки',
  'Высокий рейтинг',
  'По названию',
  'По дате добавления',
];

const listOptions = ['3', '18', '33', '48'];

const Cat = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [apiUrl, setApiUrl] = useState('');
  const [products, setProducts] = useState([]);
  const [selectedSort, setSelectedSort] = useState('По дате добавления');
  const [selectedList, setSelectedList] = useState('33');
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [isFiltersOpen, setIsFiltersOpen] = useState(true);
  const [isPriceOpen, setIsPriceOpen] = useState(true);
  const [isBrandOpen, setIsBrandOpen] = useState(true);
  const [priceRange, setPriceRange] = useState([0, 0]);
  const [debouncedPriceRange, setDebouncedPriceRange] = useState([0, 0]);
  const [actualMinPrice, setActualMinPrice] = useState(0);
  const [actualMaxPrice, setActualMaxPrice] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 675);
  const [isSortDropdownOpen, setIsSortDropdownOpen] = useState(false);
  const [isListDropdownOpen, setIsListDropdownOpen] = useState(false);
  const [brands, setBrands] = useState([]);
  const { addToCart } = useContext(CartContext);

  
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedPriceRange(priceRange);
    }, 100);
    return () => clearTimeout(handler);
  }, [priceRange]);

  useEffect(() => {
    axios.get('/templates/api.txt')
      .then(res => setApiUrl(res.data.trim()))
      .catch(err => console.error('Ошибка при загрузке API URL:', err));
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 675);
      if (window.innerWidth > 675) {
        setIsSortDropdownOpen(false);
        setIsListDropdownOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!apiUrl) return;
    axios.get(`${apiUrl}api/brands`)
      .then(res => setBrands(res.data))
      .catch(err => console.error('Ошибка при загрузке брендов:', err));
  }, [apiUrl]);

  const fetchPriceRange = async () => {
    if (!apiUrl) return;
    try {
      const response = await axios.get(`${apiUrl}api/products/price-range`);
      const { min_price, max_price } = response.data;
      setActualMinPrice(min_price);
      setActualMaxPrice(max_price);
      const minParam = searchParams.get('minPrice');
      const maxParam = searchParams.get('maxPrice');
      if (minParam && maxParam) {
        const minP = Math.max(Number(minParam), min_price);
        const maxP = Math.min(Number(maxParam), max_price);
        setPriceRange([minP, maxP]);
      } else {
        setPriceRange([min_price, max_price]);
      }
    } catch (err) {
      console.error('Ошибка при получении глобальных min/max цены:', err);
    }
  };

  useEffect(() => {
    if (apiUrl) {
      fetchPriceRange();
    }
  }, [apiUrl]);

  const fetchProducts = async () => {
    if (!apiUrl) return;
    setLoading(true);
    setError(null);
    try {
      const params = { page: currentPage, per_page: selectedList };
      if (selectedFilters.length > 0) {
        selectedFilters.forEach(f => {
          params['filters[]'] = params['filters[]'] || [];
          params['filters[]'].push(f);
        });
      }
      if (selectedBrands.length > 0) {
        selectedBrands.forEach(b => {
          params['brands[]'] = params['brands[]'] || [];
          params['brands[]'].push(b);
        });
      }
      params.min_price = debouncedPriceRange[0];
      params.max_price = debouncedPriceRange[1];

      if (selectedSort === 'Сначала Дешевые') {
        params.sort_by_stars = 'asc';
      } else if (selectedSort === 'Сначала Дорогие') {
        params.sort_by_stars = 'desc';
      }

      if (searchQuery.trim() !== '') {
        params.search = searchQuery.trim();
      }

      const res = await axios.get(`${apiUrl}api/products`, { params });
      const { products: fetched, total_pages, current_page } = res.data;
      setProducts(fetched);
      setTotalPages(total_pages);
      setCurrentPage(current_page);
    } catch (err) {
      console.error('Ошибка при загрузке товаров:', err);
      setError('Не удалось загрузить товары. Попробуйте позже.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
    
  }, [
    apiUrl,
    currentPage,
    selectedList,
    selectedFilters,
    selectedBrands,
    selectedSort,
    debouncedPriceRange,
    searchQuery
  ]);

  useEffect(() => {
    const f = searchParams.getAll('filters');
    const b = searchParams.getAll('brands');
    const s = searchParams.get('sort');
    const l = searchParams.get('list');
    const p = searchParams.get('page');
    const sq = searchParams.get('search');

    if (f.length > 0) setSelectedFilters(f);
    if (b.length > 0) setSelectedBrands(b);
    if (s) setSelectedSort(s);
    if (l) setSelectedList(l);
    setCurrentPage(p ? parseInt(p, 10) || 1 : 1);
    if (sq) setSearchQuery(sq);
    
  }, [searchParams]);

  useEffect(() => {
    const params = {};
    if (selectedFilters.length > 0) params.filters = selectedFilters;
    if (selectedBrands.length > 0) params.brands = selectedBrands;
    if (priceRange[0] !== 0 || priceRange[1] !== 0) {
      params.minPrice = priceRange[0];
      params.maxPrice = priceRange[1];
    }
    if (selectedSort && selectedSort !== 'По дате добавления') {
      params.sort = selectedSort;
    }
    if (selectedList && selectedList !== '33') {
      params.list = selectedList;
    }
    if (currentPage && currentPage !== 1) {
      params.page = currentPage;
    }
    if (searchQuery.trim() !== '') {
      params.search = searchQuery.trim();
    }
    setSearchParams(params);
    
  }, [
    selectedFilters,
    selectedBrands,
    priceRange,
    selectedSort,
    selectedList,
    currentPage,
    searchQuery
  ]);

  const handleSortSelection = (option) => {
    setSelectedSort(option);
    setCurrentPage(1);
    if (isMobile) setIsSortDropdownOpen(false);
  };

  const handleListSelection = (option) => {
    setSelectedList(option);
    setCurrentPage(1);
    if (isMobile) setIsListDropdownOpen(false);
  };

  const handleFilterChange = (option) => {
    setSelectedFilters(
      selectedFilters.includes(option)
        ? selectedFilters.filter(f => f !== option)
        : [...selectedFilters, option]
    );
    setCurrentPage(1);
  };

  const handleBrandChange = (option) => {
    setSelectedBrands(
      selectedBrands.includes(option)
        ? selectedBrands.filter(b => b !== option)
        : [...selectedBrands, option]
    );
    setCurrentPage(1);
  };

  const handlePriceChange = (range) => {
    setPriceRange(range);
    setCurrentPage(1);
  };

  const handleMinInputChange = (e) => {
    const val = parseInt(e.target.value, 10);
    if (!isNaN(val)) {
      const newMin = Math.min(val, priceRange[1]);
      setPriceRange([newMin, priceRange[1]]);
    } else {
      setPriceRange([actualMinPrice, priceRange[1]]);
    }
    setCurrentPage(1);
  };

  const handleMaxInputChange = (e) => {
    const val = parseInt(e.target.value, 10);
    if (!isNaN(val)) {
      const newMax = Math.max(val, priceRange[0]);
      setPriceRange([priceRange[0], newMax]);
    } else {
      setPriceRange([priceRange[0], actualMaxPrice]);
    }
    setCurrentPage(1);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const toggleFilters = () => setIsFiltersOpen(!isFiltersOpen);
  const togglePrice = () => setIsPriceOpen(!isPriceOpen);
  const toggleBrand = () => setIsBrandOpen(!isBrandOpen);

  const clearFilters = (e) => {
    e.stopPropagation();
    setSelectedFilters([]);
    setCurrentPage(1);
  };

  const clearBrands = (e) => {
    e.stopPropagation();
    setSelectedBrands([]);
    setCurrentPage(1);
  };

  const clearPrice = (e) => {
    e.stopPropagation();
    setPriceRange([actualMinPrice, actualMaxPrice]);
    setCurrentPage(1);
  };

  const getFilterColor = (filterName) => {
    const f = filterOptions.find(opt => opt.name === filterName);
    return f ? f.color : '#000';
  };

  const handleAddToCart = (e, product) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product, 1);
    toast.success('Товар добавлен в корзину!');
  };

  const handlePageChange = (num) => {
    if (num < 1 || num > totalPages) return;
    setCurrentPage(num);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const maxVisible = 7;
    let start = Math.max(currentPage - 3, 1);
    let end = Math.min(start + maxVisible - 1, totalPages);

    if (end - start < maxVisible - 1) {
      start = Math.max(end - maxVisible + 1, 1);
    }

    if (start > 1) {
      pages.push(1);
      if (start > 2) pages.push('ellipsis-start');
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages) {
      if (end < totalPages - 1) pages.push('ellipsis-end');
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className="cat-container">
      {/* МЕТАТЕГИ для каталога */}
      <Helmet>
        <title>Сигареты | магазин сигарет и табака</title>
        <meta
          name="description"
          content="Большой выбор сигарет. Купить сигареты оптом, табак для кальяна, сигареты Marlboro, сигареты Winston, табак для самокруток, сигареты Parliament, табак Dark Side, купить табак для кальяна."
        />
        <meta
          name="keywords"
          content="каталог сигарет, купить сигареты оптом, табак для кальяна, сигареты Marlboro, сигареты Winston, табак для самокруток, сигареты Parliament, табак Dark Side, купить табак для кальяна"
        />
      </Helmet>

      <div className="cat-text-buttons">
        <div className="search-container">
          <FaSearch className="search-icon" />
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Поиск..."
            className="search-input"
          />
        </div>

        <div className="dropdown">
          <button
            className="cat-text-button"
            onClick={isMobile ? () => setIsSortDropdownOpen(!isSortDropdownOpen) : undefined}
          >
            Сортировать <FaChevronDown className="icon" />
          </button>
          <div className={`dropdown-content ${isMobile && isSortDropdownOpen ? 'open' : ''}`}>
            {sortOptions.map(opt => (
              <button
                key={opt}
                className="dropdown-item"
                onClick={() => handleSortSelection(opt)}
              >
                {opt}
                {selectedSort === opt && <FaCheck className="check-icon" />}
              </button>
            ))}
          </div>
        </div>

        <div className="dropdown">
          <button
            className="cat-text-button"
            onClick={isMobile ? () => setIsListDropdownOpen(!isListDropdownOpen) : undefined}
          >
            Список <FaChevronDown className="icon" />
          </button>
          <div className={`dropdown-content ${isMobile && isListDropdownOpen ? 'open' : ''}`}>
            {listOptions.map(opt => (
              <button
                key={opt}
                className="dropdown-item"
                onClick={() => handleListSelection(opt)}
              >
                {opt}
                {selectedList === opt && <FaCheck className="check-icon" />}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="catalog-block">
        <div className="catalog-left">
          <div className="filters-header" onClick={toggleFilters}>
            <h2 className="filters-title">ФИЛЬТРЫ</h2>
            <div className="filters-controls">
              {isFiltersOpen && selectedFilters.length > 0 && (
                <button className="clear-filters-button" onClick={clearFilters}>
                  <FaTimes />
                </button>
              )}
              <div className="toggle-icon">
                {isFiltersOpen ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </div>
          </div>

          <div className="filters-container">
            <div className={`filters ${isFiltersOpen ? 'open' : 'closed'}`}>
              {filterOptions.map(opt => (
                <label key={opt.name} className="filter-item">
                  <input
                    type="checkbox"
                    checked={selectedFilters.includes(opt.name)}
                    onChange={() => handleFilterChange(opt.name)}
                  />
                  <span
                    className="custom-checkbox"
                    style={{
                      backgroundColor: selectedFilters.includes(opt.name) ? opt.color : '#fff',
                      borderColor: selectedFilters.includes(opt.name) ? opt.color : '#000',
                    }}
                  />
                  {opt.name}
                </label>
              ))}
            </div>

            <div className="horizontal-line bottom-line"></div>

            <div className="price-section">
              <div className="price-header" onClick={togglePrice}>
                <h3 className="price-title">Цена</h3>
                <div className="price-controls">
                  {isPriceOpen && (priceRange[0] !== actualMinPrice || priceRange[1] !== actualMaxPrice) && (
                    <button className="clear-price-button" onClick={clearPrice}>
                      <FaTimes />
                    </button>
                  )}
                  <div className="toggle-icon">
                    {isPriceOpen ? <FaChevronUp /> : <FaChevronDown />}
                  </div>
                </div>
              </div>
              <div className={`price-content ${isPriceOpen ? 'open' : 'closed'}`}>
                <div className="slider-container">
                  <Slider
                    range
                    min={actualMinPrice}
                    max={actualMaxPrice}
                    value={priceRange}
                    onChange={handlePriceChange}
                    trackStyle={[{ backgroundColor: '#000', height: 4 }]}
                    handleStyle={[
                      { borderColor: '#000', height: 16, width: 16, marginLeft: -8, marginTop: -6, backgroundColor: '#000' },
                      { borderColor: '#000', height: 16, width: 16, marginLeft: -8, marginTop: -6, backgroundColor: '#000' }
                    ]}
                    railStyle={{ backgroundColor: '#000', height: 4 }}
                  />
                  <div className="price-inputs">
                    <div className="price-input-group">
                      <label>От</label>
                      <input
                        type="number"
                        value={priceRange[0]}
                        min={actualMinPrice}
                        max={priceRange[1]}
                        onChange={handleMinInputChange}
                        className="price-input"
                      />
                    </div>
                    <div className="price-input-group">
                      <label>До</label>
                      <input
                        type="number"
                        value={priceRange[1]}
                        min={priceRange[0]}
                        max={actualMaxPrice}
                        onChange={handleMaxInputChange}
                        className="price-input"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="horizontal-line price-bottom-line"></div>

            <div className="brand-section">
              <div className="brand-header" onClick={toggleBrand}>
                <h3 className="brand-title">Бренд</h3>
                <div className="brand-controls">
                  {isBrandOpen && selectedBrands.length > 0 && (
                    <button className="clear-brands-button" onClick={clearBrands}>
                      <FaTimes />
                    </button>
                  )}
                  <div className="toggle-icon">
                    {isBrandOpen ? <FaChevronUp /> : <FaChevronDown />}
                  </div>
                </div>
              </div>
              <div className={`brand-content ${isBrandOpen ? 'open' : 'closed'}`}>
                <div className="filters">
                  {brands.map(opt => (
                    <label key={opt} className="filter-item">
                      <input
                        type="checkbox"
                        checked={selectedBrands.includes(opt)}
                        onChange={() => handleBrandChange(opt)}
                      />
                      <span className="custom-checkbox" />
                      {opt}
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="catalog-right">
          {loading ? (
            <div className="loading-animation">
              <div className="cigarette">
                <div className="cigarette-body"></div>
                <div className="cigarette-filter"></div>
              </div>
              <div className="smoke">
                <div className="smoke-puff puff1"></div>
                <div className="smoke-puff puff2"></div>
                <div className="smoke-puff puff3"></div>
              </div>
            </div>
          ) : error ? (
            <p className="error-message">{error}</p>
          ) : (
            <>
              <div className="cards-container">
                {products.length > 0 ? (
                  products.map(product => (
                    <div key={product.id} className="card">
                      <Link to={`/catalog/${product.slug}`} className="card-link">
                        <div className="card-inner">
                          <Photo
                            src={product.image}
                            alt={product.title}
                            apiUrl={apiUrl}
                            className="card-image"
                          />
                          <div className="card-filters">
                            {product.filters.map(fl => (
                              <div key={fl} className="card-filter">
                                <span
                                  className="filter-color"
                                  style={{ backgroundColor: getFilterColor(fl) }}
                                />
                                {fl}
                              </div>
                            ))}
                          </div>
                          {!product.inStock && (
                            <div className="card-overlay">
                              <span className="overlay-text">Нет в наличии</span>
                            </div>
                          )}
                          {product.inStock && (
                            <button
                              className="add-to-cart-button"
                              onClick={(e) => handleAddToCart(e, product)}
                            >
                              В корзину
                            </button>
                          )}
                          {['Топ 25', 'Бестселлер', 'Новинка'].some(tag => product.filters.includes(tag)) && (
                            <MdOutlineStar className="star-icon" />
                          )}
                        </div>
                        <div className="card-description">
                          <p className="card-title">{product.title}</p>
                          <p className="card-price">{product.price.toLocaleString()} ₽</p>
                          {Object.entries(product.attributes).map(([k, v]) =>
                            v ? <p key={k} className="card-attribute">{k}: {v}</p> : null
                          )}
                        </div>
                      </Link>
                    </div>
                  ))
                ) : (
                  <p className="no-products-message">Нет товаров под ваш запрос.</p>
                )}
              </div>

              {totalPages > 1 && (
                <div className="pagination-container">
                  <button
                    className="pagination-button"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    &laquo;
                  </button>
                  {generatePageNumbers().map((page, i) => {
                    if (page === 'ellipsis-start' || page === 'ellipsis-end') {
                      return (
                        <span key={i} className="pagination-ellipsis">
                          ...
                        </span>
                      );
                    }
                    return (
                      <button
                        key={i}
                        className={`pagination-button ${currentPage === page ? 'active' : ''}`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    );
                  })}
                  <button
                    className="pagination-button"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    &raquo;
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Cat;
